export default __webpack_public_path__ + "static/online_dating_2-227fa8cec4da397c2165382f6d551f6f.png";